<template>
	<section class="w-full max-w-5xl mx-auto">
		<div class="relative w-full flex flex-col bg-white">
			<div class="flex flex-col">
        <div class="flex">
          <div class="w-full flex my-2 h-8">
            <span class="flex-1 self-center border-t border-gray-300"></span>
            <span class="text-xl font-semibold text-blue-900 text-center px-3">
              <svg viewBox="0 0 1640 404" class="h-8 ml-3"><g><path d="M197 19l154 0c17,0 30,15 30,34l0 292 -14 0 0 -289c0,-13 -9,-23 -21,-23l-149 0 0 -14zm-15 385l-151 0c-17,0 -31,-16 -31,-34l0 -307 14 0 0 303c0,13 10,23 21,23l147 0 0 15z" style="fill: rgb(11, 69, 132);"></path> <path d="M197 38l145 0c11,0 20,10 20,23l0 284 -14 0 0 -277c0,-8 -7,-15 -14,-15l-137 0 0 -15zm-15 346l-142 0c-11,0 -20,-10 -20,-23l0 -298 14 0 0 291c0,9 6,16 14,16l134 0 0 14z" style="fill: rgb(227, 30, 36);"></path> <path d="M1141 298l0 -75c0,-11 0,-45 -42,-45l-48 0c15,0 32,13 32,32l0 88 58 0z" style="fill: rgb(11, 69, 132);"></path> <path d="M1073 298l0 -64 -20 0c-51,0 -51,64 -1,64l21 0z" style="fill: rgb(11, 69, 132);"></path> <path d="M931 298l0 -120 -17 0c-70,0 -68,120 0,120l17 0z" style="fill: rgb(11, 69, 132);"></path> <circle cx="1049" cy="205" r="24" style="fill: rgb(11, 69, 132);"></circle> <path d="M1640 298l0 -75c0,-11 0,-45 -41,-45l-49 0c15,0 32,13 32,32l0 88 58 0z" style="fill: rgb(11, 69, 132);"></path> <path d="M1572 298l0 -64 -20 0c-51,0 -51,64 -1,64l21 0z" style="fill: rgb(11, 69, 132);"></path> <circle cx="1549" cy="205" r="24" style="fill: rgb(11, 69, 132);"></circle> <path d="M1156 178l59 0 0 120c-20,0 -59,5 -59,-44l0 -76z" style="fill: rgb(11, 69, 132);"></path> <path d="M1298 298l59 0 0 -120c-20,0 -59,-4 -59,45l0 75z" style="fill: rgb(11, 69, 132);"></path> <path d="M1283 178l-59 0 0 120c20,0 59,5 59,-44l0 -76z" style="fill: rgb(11, 69, 132);"></path> <path d="M1426 298l-59 0 0 -120c19,0 59,-4 59,45l0 75z" style="fill: rgb(11, 69, 132);"></path> <rect x="1440" y="178" width="58.981" height="120.078" style="fill: rgb(11, 69, 132);"></rect> <rect x="789" y="178" width="58.981" height="120.078" style="fill: rgb(11, 69, 132);"></rect> <rect x="642" y="172" width="58.981" height="126.767" style="fill: rgb(11, 69, 132);"></rect> <rect x="258" y="172" width="58.981" height="126.767" style="fill: rgb(11, 69, 132);"></rect> <polygon points="447,298 607,114 689,114 530,298 " style="fill: rgb(11, 69, 132);"></polygon> <polygon points="63,298 223,114 304,114 145,298 " style="fill: rgb(11, 69, 132);"></polygon> <rect x="941" y="114" width="58.981" height="184.307" style="fill: rgb(11, 69, 132);"></rect> <rect x="715" y="114" width="58.981" height="184.307" style="fill: rgb(11, 69, 132);"></rect> <circle cx="818" cy="146" r="28" style="fill: rgb(11, 69, 132);"></circle> <circle cx="1470" cy="146" r="28" style="fill: rgb(11, 69, 132);"></circle> <path d="M156 37l-24 0 -27 4 -2 -4 0 0 -41 0 0 8 -9 0 -1 -8 -21 0 -7 -4c-5,1 -22,4 -24,8 -3,6 18,6 21,6 6,1 18,0 26,0 6,0 15,0 19,1 2,0 4,1 8,2l5 -10 15 0 18 8c8,-1 17,-3 25,-5 1,0 2,0 2,1 2,0 2,-2 3,-2 2,-1 13,-5 14,-5zm-95 0l-8 0 1 7 7 0 0 -7zm64 0l-21 0 0 0 2 2 19 -2zm-49 13c3,0 7,1 13,1 1,0 9,-1 10,-1 4,0 7,-1 11,-1l-17 -7 -13 0 -4 8z" style="fill: rgb(227, 30, 36);"></path> <path d="M27 32l3 3 22 0 2 -9 8 0 0 9 41 0 0 -9 1 0 0 9 26 0 1 -8 2 0 -1 8 32 0c2,-1 6,-2 8,-3 2,-1 2,-3 0,-4 0,-2 17,-24 20,-28 -19,0 -22,0 -28,5l-27 20c0,1 -5,0 -6,0 -8,-2 -19,-3 -27,-2 0,0 -1,0 -1,0 0,0 -1,0 -1,1 -16,-1 -32,-1 -48,-1 -4,0 -11,0 -15,1 -2,1 -6,5 -9,6 0,1 -3,2 -3,2zm26 3l8 0 0 -9 -6 0 -2 9zm-13 -10l3 0 -1 1 5 0 -1 5 -7 0 -1 2 -8 -1 10 -7zm0 1l1 0 0 0 -3 4 -1 2 -4 -1 7 -5zm2 0l4 0 -1 4 -6 0 3 -4zm141 -24l3 2 -2 -2 -8 0 -7 2 3 1 -1 -1 5 -2 7 0zm-4 5l5 -1 -5 0 -21 21 12 0 0 0 -10 0 19 -20zm-103 25c1,-2 1,-4 0,-5 -1,0 -2,0 -2,1 -1,0 -2,4 0,4 1,0 2,0 2,0zm9 -4c-1,-1 -2,-1 -2,-1 -2,1 -2,5 -1,5 0,1 2,0 2,0 1,0 1,0 1,-1 1,-1 0,-2 0,-3zm-29 0c0,0 0,0 0,0 0,0 0,0 0,0 -1,1 -1,2 0,3 0,1 0,1 1,1 0,0 2,0 2,0 1,0 1,-4 0,-5 -1,0 -2,0 -3,1zm9 4c0,0 1,0 2,0 1,0 1,0 1,-1 0,-1 0,-3 0,-3 -1,-1 -2,-1 -2,-1 -1,1 -1,1 -2,2 0,1 0,2 1,3z" style="fill: rgb(11, 69, 132);"></path> <path d="M212 380c0,0 -3,1 -3,1 0,1 0,1 0,2 2,3 54,10 58,10 1,0 9,2 9,3 1,1 9,4 10,4 2,0 4,0 5,1 4,1 16,0 16,1 1,1 0,2 3,2 11,0 21,0 32,0 1,0 3,-1 3,-2 5,0 28,1 29,-5 0,-4 -14,-7 -16,-7 -1,-1 -1,-1 -1,-2l-4 0 1 1c0,2 -1,3 -2,4 -3,2 -4,1 -5,1l-2 -5 -1 0 1 3c1,1 0,3 -1,3l-1 0 -5 0c-2,0 -3,-1 -3,-2l0 -4 -5 0 0 3c0,1 -1,2 -2,2l-7 0c0,0 0,0 -1,-1l0 -4 -1 0 0 4c0,1 0,1 -1,1l-7 0c-1,0 -1,-1 -1,-2l-1 -3 -19 0 -78 -9z" style="fill: rgb(11, 69, 132);"></path> <path d="M285 372c-1,1 -1,0 -1,1 -4,1 -8,2 -12,3 -2,1 -1,1 -3,1 -11,0 -23,1 -35,1 -1,0 -2,-1 -3,-1 -3,-1 -5,-4 -7,-6 -2,-2 -5,-5 -7,-8 -1,0 -1,0 -1,-1 -1,-1 -1,-1 -1,-2 0,0 0,0 0,0 0,-1 0,-2 -1,-2 0,0 0,-1 1,-1 1,0 1,1 1,-1 1,-2 4,-7 4,-9 -1,0 -2,-1 -3,0 -1,2 -3,10 -4,10 0,1 -1,2 -1,2l-5 2c0,0 -1,-1 -1,-1 -2,0 -10,1 -11,1 0,1 0,1 1,2 1,1 1,0 3,0 2,0 5,0 7,-1 0,0 9,13 9,16 0,0 0,0 0,1 0,0 68,7 74,8l20 0 0 -2c0,-1 1,-2 2,-2l6 0c1,0 1,1 1,2l1 2 1 0 0 -2c0,-1 0,-2 2,-2l5 0c1,0 2,1 2,2l0 2 6 0 -1 -4c0,0 1,-1 2,-1l3 0c1,0 2,0 2,1l2 4 1 0 -2 -4c0,-1 0,-1 1,-1l2 -1 7 6 4 0c-1,-1 -2,-2 -3,-2 0,0 0,0 -1,0 0,0 -2,-2 -2,-2l-1 0c0,-1 -2,-2 -3,-3 -3,-1 -4,-2 -7,-3 -1,-1 0,0 -2,-1 1,0 1,0 1,0 2,0 6,-5 6,-6 0,0 -5,4 -6,5 -1,0 -2,0 -3,1 -1,0 -2,0 -3,-1 0,0 0,0 0,-1l-47 -2zm55 7l-5 -1 -1 2 1 1 5 0 3 -1 -3 -1z" style="fill: rgb(227, 30, 36);"></path> <path d="M291 361c-16,-1 -31,-3 -47,-4 -1,-1 -7,-1 -8,-1 0,0 -1,0 -1,0 -1,0 -2,0 -3,0 0,0 -1,1 -1,1 0,0 0,0 0,0 1,0 2,-1 4,-1 0,0 1,0 1,0 15,2 30,4 44,6l6 0c0,0 -1,0 -1,1 0,0 1,0 1,0 1,0 1,0 1,0l0 -1 1 1c1,0 1,0 1,0 0,0 2,0 2,0l1 -1 14 2 0 1c1,0 2,0 2,0 1,0 1,0 2,0 0,1 0,2 -1,2 -3,0 -8,0 -11,1 -3,0 -6,1 -9,1 0,0 -1,2 -1,3 0,0 29,1 40,1 -1,-2 -3,-3 -4,-4 -2,-1 -4,-1 -7,-1 0,0 1,-2 1,-2 0,0 2,0 2,0 0,0 1,0 0,0 0,-1 -1,0 0,-1 1,0 6,1 7,1 3,1 2,1 6,1 13,2 26,3 39,4 2,0 3,0 5,1 1,0 1,1 2,1 1,0 1,0 2,0l1 0c0,0 -3,-2 -4,-2 0,0 -1,0 -2,0l-54 -7c-1,0 -1,0 -1,0 0,0 0,0 0,-1 -1,0 -2,0 -2,0 0,1 0,1 0,0l-4 0c0,0 0,0 1,0 0,0 1,0 2,0 0,0 0,-1 -1,-1 -1,0 -1,-2 -3,-2 -2,0 -2,1 -3,1 -1,1 -1,1 -1,1 0,0 2,0 2,0 0,0 0,0 0,1 0,0 -5,-1 -6,-1l0 0 1 1c-6,-1 -11,-1 -16,-2z" style="fill: rgb(227, 30, 36);"></path></g></svg>
            </span>
            <span class="flex-1 self-center border-t border-gray-300"></span>
          </div>
        </div>
        <div class="flex flex-col md:flex-row mb-10">

          <!-- BEGIN CONTENT -->
          <!-- <router-view /> -->
          <div v-if="! iframeSrc" class="w-full text-sm lg:w-2/3 px-6 xl:px-0" />
          <iframe :src="iframeSrc" id="company-iframe" class="w-full text-sm lg:w-2/3 px-6 xl:px-0" />
          <!-- END CONTENT -->

          <!-- BEGIN SIDEBAR -->
          <div class="hidden lg:block w-full md:w-1/3 md:pl-10 mt-5 md:mt-0 px-2">

            <agile :autoplay-speed="3000" :speed="1500" pause-on-hover="pause-on-hover" pause-on-dots-hover="pause-on-dots-hover" autoplay="autoplay">
              <div class="slide" v-for="photo in photos">
                <img style="height:200px" :src="`/img/company/company-0${photo}.jpg`" />
              </div>
              <template slot="prevButton">
                <fa class="s-chevron-left" />
              </template>
              <template slot="nextButton">
                <fa class="s-chevron-right" />
              </template>
            </agile>

            <!-- CATEGORIES START -->
            <ul id="sidebarMenu" class="mt-5">

              <li class="hover:bg-gray-200 text-blue-800 cursor-pointer border-b p-1" :class="sidebarItemActive('company-profile')">
                <router-link :to="{ name: 'company-profile' }" class="flex justify-between items-center">
                  <span v-if="lang == 'it'">Azienda</span>
                  <span v-if="lang == 'en'">Company</span>
                  <fa class="s-caret-right text-base mr-1" />
                </router-link>
              </li>

              <li class="hover:bg-gray-200 text-blue-800 cursor-pointer border-b p-1" :class="sidebarItemActive('company-flight-operations')">
                <router-link :to="{ name: 'company-flight-operations' }" class="flex justify-between items-center">
                  <span v-if="lang == 'it'">Operazioni Volo</span>
                  <span v-if="lang == 'en'">Flight Operations</span>
                  <fa class="s-caret-right text-base mr-1" />
                </router-link>
              </li>

              <li class="hover:bg-gray-200 text-blue-800 cursor-pointer border-b p-1" :class="sidebarItemActive('company-civil-protection')">
                <router-link :to="{ name: 'company-civil-protection' }" class="flex justify-between items-center">
                  <span v-if="lang == 'it'">Protezione Civile</span>
                  <span v-if="lang == 'en'">Civil Protection</span>
                  <fa class="s-caret-right text-base mr-1" />
                </router-link>
              </li>

              <li class="hover:bg-gray-200 text-blue-800 cursor-pointer border-b p-1" :class="sidebarItemActive('company-scheduled-flights')">
                <router-link :to="{ name: 'company-scheduled-flights' }" class="flex justify-between items-center">
                  <span v-if="lang == 'it'">Voli di linea</span>
                  <span v-if="lang == 'en'">Scheduled Flights</span>
                  <fa class="s-caret-right text-base mr-1" />
                </router-link>
              </li>

              <li class="hover:bg-gray-200 text-blue-800 cursor-pointer border-b p-1" :class="sidebarItemActive('company-offshore')">
                <router-link :to="{ name: 'company-offshore' }" class="flex justify-between items-center">
                  <span v-if="lang == 'it'">Operazioni Offshore</span>
                  <span v-if="lang == 'en'">Offshore Helicopter Services</span>
                  <fa class="s-caret-right text-base mr-1" />
                </router-link>
              </li>

              <li class="relative hover:bg-gray-200 text-blue-800 cursor-pointer border-b p-1" :class="sidebarItemActive('company-medical-transport')">
                <img src="/img/new.png" class="absolute top-0 left-0">
                <router-link :to="{ name: 'company-medical-transport' }" class="flex justify-between items-center" style="padding-left:20px">
                  <span v-if="lang == 'it'">Trasporti Aerei Sanitari</span>
                  <span v-if="lang == 'en'">Medical Transport</span>
                  <fa class="s-caret-right text-base mr-1" />
                </router-link>
              </li>

              <li class="hover:bg-gray-200 text-blue-800 cursor-pointer border-b p-1" :class="sidebarItemActive('company-additional-services')">
                <router-link :to="{ name: 'company-additional-services' }" class="flex justify-between items-center">
                  <span v-if="lang == 'it'">Servizi aggiuntivi</span>
                  <span v-if="lang == 'en'">Other operating activities</span>
                  <fa class="s-caret-right text-base mr-1" />
                </router-link>
              </li>

              <li class="hover:bg-gray-200 text-blue-800 cursor-pointer border-b p-1" :class="sidebarItemActive('company-maintenance')">
                <router-link :to="{ name: 'company-maintenance' }" class="flex justify-between items-center">
                  <span v-if="lang == 'it'">Attività di manutenzione</span>
                  <span v-if="lang == 'en'">Aircraft maintenance</span>
                  <fa class="s-caret-right text-base mr-1" />
                </router-link>
              </li>

              <li class="hover:bg-gray-200 text-blue-800 cursor-pointer border-b p-1" :class="sidebarItemActive('company-auths-certs')">
                <router-link :to="{ name: 'company-auths-certs' }" class="flex justify-between items-center">
                  <span v-if="lang == 'it'">Autorizzazioni e certificazioni</span>
                  <span v-if="lang == 'en'">Authorizations</span>
                  <fa class="s-caret-right text-base mr-1" />
                </router-link>
              </li>

              <li class="hover:bg-gray-200 text-blue-800 cursor-pointer border-b p-1" :class="sidebarItemActive('company-heliport-design-construction-management')">
                <router-link :to="{ name: 'company-heliport-design-construction-management' }" class="flex justify-between items-center">
                  <span v-if="lang == 'it'">Progettazione, costruzione e gestione eliporti</span>
                  <span v-if="lang == 'en'">Heliports design construction and management</span>
                  <fa class="s-caret-right text-base mr-1" />
                </router-link>
              </li>

              <li class="hover:bg-gray-200 text-blue-800 cursor-pointer border-b p-1" :class="sidebarItemActive('company-apulian-heli-network')">
                <router-link :to="{ name: 'company-apulian-heli-network' }" class="flex justify-between items-center">
                  <span v-if="lang == 'it'">Rete Eliportuale Pugliese</span>
                  <span v-if="lang == 'en'">Apulian Heliport Network</span>
                  <fa class="s-caret-right text-base mr-1" />
                </router-link>
              </li>

              <!--
              <li v-if="$route.name == 'company-apulian-heli-network'" class="hover:bg-gray-200 text-blue-800 cursor-pointer flex justify-between items-center">
                <router-link :to="{ name: 'company-apulian-heli-network', hash: '?foggia' }" class="border-b-2 py-1 flex-1 pl-2 text-xs border-l-8 border-r-8 border-blue-100">
                  <fa class="s-caret-right text-base mr-1" />
                  Foggia
                </router-link>
              </li>

              <li v-if="$route.name == 'company-apulian-heli-network'" class="hover:bg-gray-200 text-blue-800 cursor-pointer flex justify-between items-center">
               <router-link :to="{ name: 'company-apulian-heli-network', hash: '?san-domino' }" class="border-b-2 py-1 flex-1 pl-2 text-xs border-l-8 border-r-8 border-blue-100">
                  <fa class="s-caret-right text-base mr-1" />
                  Isole Tremiti San Domino
                </router-link>
              </li>

              <li v-if="$route.name == 'company-apulian-heli-network'" class="hover:bg-gray-200 text-blue-800 cursor-pointer flex justify-between items-center">
               <router-link :to="{ name: 'company-apulian-heli-network', hash: '?vieste' }" class="border-b-2 py-1 flex-1 pl-2 text-xs border-l-8 border-r-8 border-blue-100">
                  <fa class="s-caret-right text-base mr-1" />
                  Vieste
                </router-link>
              </li>

              <li v-if="$route.name == 'company-apulian-heli-network'" class="hover:bg-gray-200 text-blue-800 cursor-pointer flex justify-between items-center">
               <router-link :to="{ name: 'company-apulian-heli-network', hash: '?melendugno' }" class="border-b-2 py-1 flex-1 pl-2 text-xs border-l-8 border-r-8 border-blue-100">
                  <fa class="s-caret-right text-base mr-1" />
                  Melendugno
                </router-link>
              </li>

              <li v-if="$route.name == 'company-apulian-heli-network'" class="hover:bg-gray-200 text-blue-800 cursor-pointer border-b flex justify-between items-center">
               <router-link :to="{ name: 'company-apulian-heli-network', hash: '?sgr' }" class="border-b-2 py-1 flex-1 pl-2 text-xs border-l-8 border-r-8 border-blue-100">
                  <fa class="s-caret-right text-base mr-1" />
                  San Giovanni Rotondo
                </router-link>
              </li>

              <li v-if="$route.name == 'company-apulian-heli-network'" class="hover:bg-gray-200 text-blue-800 cursor-pointer border-b flex justify-between items-center">
               <router-link :to="{ name: 'company-apulian-heli-network', hash: '?celenza' }" class="border-b-2 py-1 flex-1 pl-2 text-xs border-l-8 border-r-8 border-blue-100">
                  <fa class="s-caret-right text-base mr-1" />
                  Celenza Valfortore
                </router-link>
              </li>

              <li v-if="$route.name == 'company-apulian-heli-network'" class="hover:bg-gray-200 text-blue-800 cursor-pointer border-b flex justify-between items-center">
               <router-link :to="{ name: 'company-apulian-heli-network', hash: '?peschici' }" class="border-b-2 py-1 flex-1 pl-2 text-xs border-l-8 border-r-8 border-blue-100">
                  <fa class="s-caret-right text-base mr-1" />
                  Peschici
                </router-link>
              </li>

              <li v-if="$route.name == 'company-apulian-heli-network'" class="hover:bg-gray-200 text-blue-800 cursor-pointer border-b flex justify-between items-center">
               <router-link :to="{ name: 'company-apulian-heli-network', hash: '?supersano' }" class="border-b-2 py-1 flex-1 pl-2 text-xs border-l-8 border-r-8 border-blue-100">
                  <fa class="s-caret-right text-base mr-1" />
                  Supersano
                </router-link>
              </li>

              <li v-if="$route.name == 'company-apulian-heli-network'" class="hover:bg-gray-200 text-blue-800 cursor-pointer border-b flex justify-between items-center">
               <router-link :to="{ name: 'company-apulian-heli-network', hash: '?bari' }" class="border-b-2 py-1 flex-1 pl-2 text-xs border-l-8 border-r-8 border-blue-100">
                  <fa class="s-caret-right text-base mr-1" />
                  Bari Policlinico
                </router-link>
              </li>

              <li v-if="$route.name == 'company-apulian-heli-network'" class="hover:bg-gray-200 text-blue-800 cursor-pointer border-b flex justify-between items-center">
               <router-link :to="{ name: 'company-apulian-heli-network', hash: '?san-nicola' }" class="border-b-8 py-1 flex-1 pl-2 text-xs border-l-8 border-r-8 border-blue-100">
                  <fa class="s-caret-right text-base mr-1" />
                  Isole Tremiti San Nicola
                </router-link>
              </li>
              -->

              <router-link tag="li" :to="{ name: 'company-doa' }" class="hover:bg-gray-200 text-blue-800 cursor-pointer border-b p-1 flex justify-between items-center" :class="sidebarItemActive('company-doa')">
                <span v-if="lang == 'it'">Organizzazione D.O.A.</span>
                <span v-if="lang == 'en'">Design Organisation D.O.A.</span>
                <fa class="s-caret-right text-base mr-1" />
              </router-link>

              <router-link tag="li" :to="{ name: 'company-training' }" class="hover:bg-gray-200 text-blue-800 cursor-pointer border-b p-1 flex justify-between items-center" :class="sidebarItemActive('company-training')">
                <span v-if="lang == 'it'">Centro di Addestramento</span>
                <span v-if="lang == 'en'">Approved Training Organization</span>
                <fa class="s-caret-right text-base mr-1" />
              </router-link>

              <router-link tag="li" :to="{ name: 'company-tea-centre' }" class="hover:bg-gray-200 text-blue-800 cursor-pointer border-b p-1 flex justify-between items-center" :class="sidebarItemActive('company-tea-centre')">
                <span v-if="lang == 'it'">Centro per esami TEA</span>
                <span v-if="lang == 'en'">Centre for TEA Examinations</span>
                <fa class="s-caret-right text-base mr-1" />
              </router-link>

              <li v-if="$route.name == 'company-profile'" class="mt-5">
                <iframe class="w-full" src="https://www.youtube.com/embed/GjgSnATuwEU" frameborder="0" allowfullscreen="" />
              </li>
            </ul>
            <!-- CATEGORIES END -->

            <div class="mt-5">
              <a href="/company/finanzia-il-tuo-addestramento">
                <img src="/img/loghi/bnl-banner.png">
              </a>
            </div>
          </div>
          <!-- END SIDEBAR -->
        </div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
  name: 'Company',
  data:() => ({
    photos: [1,2,3,4,5],
    page: 'profile',
    hash: null
  }),
  computed: {
    lang() {
      return this.$parent.lang
    },
    iframeSrc() {
      return '/company-pages/' + this.lang + '/' + this.page + (location.href.includes('?preview') ? '?preview' : '') + (this.hash ? '#' + this.hash : '')
    }
  },
  watch: {
    $route(val) {
      // console.log(val)
      let page = val.name.replace('company-', '')
      let hash = val.hash ? val.hash.replace('?', '') : null
      this.page = page
      this.hash = hash
    }
  },
  methods: {
    detectCurrentPage() {
			// console.log(location.pathname)
			let pathname = location.pathname
			if (pathname == '/company') { pathname = '/company/' }
			let page = pathname.replace('/company/', '') || 'profile'
			// console.log(page)
			this.page = page
		},
    addListenerToIframe() {
      // var _iframe = document.getElementsByTagName('iframe')[0]
      var _iframe = document.getElementById('company-iframe')
      var handleLoad = () => {
        this.setIframeHeight()
        this.isLoading = false
      }
      _iframe.addEventListener('load', handleLoad, true)
    },
    setIframeHeight() {
      // var _iframe = document.getElementsByTagName('iframe')[0]
      var _iframe = document.getElementById('company-iframe')
      var _document = _iframe.contentWindow.document
      var _body = _document.getElementsByTagName('body')[0]
      // let heightString = getComputedStyle(_body).height
      let heightNum = _body.offsetHeight || 680
      let heightString = heightNum + 20 + 'px'
      console.log(heightString)
      _iframe.style.height = heightString
    },
    resetIframe() {
      // var _iframe = document.getElementsByTagName('iframe')[0]
      var _iframe = document.getElementById('company-iframe')
      _iframe.style.height = '0px'
      this.iframeSrc = null
    },
    sidebarItemActive(route) {
      if (route == this.$route.name) {
        return ['font-semibold text-blue-800 bg-blue-100']
      }
    }
  },
  mounted() {
    this.detectCurrentPage()
    this.addListenerToIframe()
  }
}
</script>
